



import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs, IconButton,
  Link, Tooltip, Chip,Autocomplete
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { SETTING_API_02, SETTING_API_08 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";

function CreateSubCategory() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [datacat, setDatacat] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const {   LOCCODE,STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    catname: "",
    subcatname: "",
    colorcode: "#000000",
    catcode:"",
    subcatcode: "",
    descrip: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
       catcode: selectedItem.catcode,
        catname: selectedItem.catname,
        subcatname: selectedItem.subcatname,
        colorcode: selectedItem.colorcode,
    subcatcode: selectedItem.subcatcode,
    descrip: selectedItem.descrip || "",
      });
    }
  }, [selectedItem]);

 console.log("Selected Item Details:", selectedItemDetails);

  useEffect(() => {
    setPageData({
      title: "Subcategory",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate("/vsubcategory");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }
  
    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setSelectedItemDetails({
      catname: "",
      subcatname: "",
      subcatcode: "",
      colorcode: "#000000",
      catcode:"",
      descrip: "",

    });
    
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_02, "get", {
          COMPCODE,
            LOCCODE:STAFFMAPLOCODE,


          STS: CON_STATUS_ACTIVE,
        });

        setDatacat(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_08, "get", {
          COMPCODE,
            LOCCODE:STAFFMAPLOCODE,


          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { subcatname,catname}= selectedItemDetails;

    const requiredFields = [
      { name: "subcatname", value: subcatname, label: "Subcategory Name" },
      { name: "catname", value: catname, label: "Category Name" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (
          item.subcatcode !== selectedItemDetails.subcatcode &&
          item.subcatname.toLowerCase() === subcatname.toLowerCase()
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Subcategory Already Exists.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    const BRAND_CODE = selectedItem ? (selectedItem.subcatcode) : 0;
    console.log("Category Code:", BRAND_CODE);

    const staticValues = {
      COMPCODE,
        LOCCODE:STAFFMAPLOCODE,


      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      subcatcode: BRAND_CODE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTING_API_08, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      setSelectedItemDetails({
        catname: "",  catname: "",
    subcatname: "",
    colorcode: "#000000",
    catcode:""
      });
      setTimeout(() => {
        navigate("/vsubcategory");
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
   
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
           Subcategory
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}> {isEdit ? "Edit Subcategory" : "Create Subcategory"}</Typography>
            </Grid>
          </Grid>
        </AppBar>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          <Grid container spacing={2} sx={styles.add_form_page_grid_container}>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              {/* <TextField
                id="Category-name"
                label="Category Name"
                variant="outlined"
                fullWidth
                size="small"
                required
                   name="catname"
                value={selectedItemDetails.catname}
                onChange={handleInputChange}
                // error={!!error.catname}
                // helperText={error.catname}
              /> */}
<Autocomplete
  options={Array.isArray(datacat) ? datacat : []} // Ensure datacat is an array
  getOptionLabel={(option) => option.catname || ""} // Use catname or fallback to an empty string
  disableClearable
  value={
    Array.isArray(datacat)
      ? datacat.find((item) => item.catcode === selectedItemDetails.catcode) || null
      : null
  } // Match the selected value or fallback to null
  onChange={(event, newValue) => {
    handleInputChange({
      target: {
        name: "catcode",
        value: newValue ? newValue.catcode : "", // Update catcode
      },
    });
    handleInputChange({
      target: {
        name: "catname",
        value: newValue ? newValue.catname : "", // Update catname
      },
    });
  }}
  renderInput={(params) => (
    <TextField
    {...params}
    name="catname"
    label={
      <span>
        Category Name<span style={{ color: "red" }}> *</span>
      </span>
    }
    variant="outlined"
    error={!!error?.catname} // Show error if catname has an issue
    helperText={error?.catname || ""} // Display the actual error message or fallback to an empty string
    FormHelperTextProps={{
      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
    }}
    size="small"
  />
  )}
  ListboxProps={{
    style: {
      maxHeight: 150,
      backgroundColor: theme.palette.background.paper,
    },
  }}
/>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}></Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <TextField
  id="Category-name"
  label="Subcategory Name"
  variant="outlined"
  fullWidth
  size="small"
  required
  name="subcatname"
  value={selectedItemDetails.subcatname || ""} // Fallback to an empty string
  onChange={handleInputChange}
  error={!!error.subcatname}
  helperText={error.subcatname}
  FormHelperTextProps={{
    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
  }}
/>
            </Grid>
            
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            
                
            {/* <TextField
              label=" Color Code"
              name="colorcode"
              type="color"
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <Chip
                    label={selectedItemDetails.colorcode}
                    type="color"
                    style={{
                      backgroundColor: selectedItemDetails.colorcode,
                      color: "white",
                      marginLeft: "10px",
                    }}
                  />
                ),
              }}
              value={selectedItemDetails.colorcode}
              onChange={handleInputChange}
       
            />
            */}
          </Grid>
           <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
          
                        <TextField
                          id="description"
                          label="Description"
                          variant="outlined"
                          fullWidth
                          size="small"
                          name="descrip"
                          value={selectedItemDetails.descrip}
                          onChange={handleInputChange}
                          error={!!error.descrip}
                          helperText={error.descrip}
                          FormHelperTextProps={{
                            sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                          }}
                        />
                      
          
                    </Grid>
          </Grid>
        </Box>
        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel} 
          >
             Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
          >
           {isEdit ? "Modify" : "Confirm"}
          </Button>
      
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default CreateSubCategory;
